import App, { DarkTheme, LightTheme } from './App';

export default App;
export { DarkTheme, LightTheme };
